module.exports = __webpack_public_path__ + "img/cart4.71770655.svg";